 <!-- Content Header (Page header) -->
 <section class="content-header">
    <div class="content-header">
       <div class="container-fluid">
         <div class="row mb-2">
           <div class="col-sm-6">
               <h3>Add Additional Duty</h3>
           </div>
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a href="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
               <li class="breadcrumb-item"><a routerLink="/recent-entries"><i class="fa fa-list-ul"></i>&nbsp;Recent Entries</a></li>
               <li class="breadcrumb-item active">Add Additional Duty</li>
             </ol>
           </div><!-- /.col -->
         </div><!-- /.row -->
       </div><!-- /.container-fluid -->
    </div>
   </section>
     <!-- /.content-header -->
   <section class="content">
   <div class="container-fluid">
   <div class="card">
       <div class="card-header">
         <h3 class="card-title">Add Additional Duty</h3>
         <!--Error messages-->
         <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
            {{errorMessage}}
          </div>
       </div>
       <!-- /.card-header -->
       <div class="card-body">
           <form [formGroup]="form" (ngSubmit)="handleSubmit()">
               <div class="row clearfix">
                    <div class="col-md-4" *ngIf="entry?.data?.make">
                       <div class="form-group">
                           <label>Make:</label>
                           <input type="text" name="make" class="form-control" placeholder="Make" value="{{ entry?.data?.make }}" readonly>
                       </div>
                    </div>
                    <div class="col-md-4" *ngIf="entry?.data?.model">
                       <div class="form-group">
                           <label>Model:</label>
                           <input type="text" name="model" class="form-control" placeholder="Model" value="{{ entry?.data?.model }}" readonly>
                       </div>
                    </div>
                    <div class="col-md-4" *ngIf="entry?.data?.chassis_no">
                      <div class="form-group">
                        <label>Chassis No.</label>
                        <input type="text" formControlName="chassis_no" [(ngModel)]="entry.data.chassis_no" class="form-control" placeholder="Chassis No." readonly>
                      </div>
                    </div>
               </div>
               <div class="row clearfix">
                    <div class="col-md-4" *ngIf="entry?.data?.colour">
                        <div class="form-group">
                            <label>Colour:</label>
                            <input type="text" name="colour" class="form-control" placeholder="Colour" value="{{ entry?.data?.colour }}" readonly>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Entry No.:</label>
                            <input type="text" formControlName="entry_no" class="form-control" placeholder="Entry No." [(ngModel)]="entry.data.entry_no" readonly>

                            <span *ngIf="submitted && form.get('entry_no')?.hasError('required')" style="color:red"><strong>Entry number appears to be missing. Please refresh this page!</strong></span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Entry Date:</label>
                            <input type="text" name="entry_date" class="form-control" placeholder="Entry Date" value="{{ entry?.data?.entry_date | date:'dd-MM-yyyy' }}" readonly>
                        </div>
                    </div>
                </div>
                <div class="separator">Payment Details</div>
                <div class="row clearfix">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Payment Type:<span style="color:red;">*</span></label>
                            <select formControlName="payment_type" class="form-control" (change)="onSelectChange($event.target)">
                                <option value="">Select</option>
                                <option value="Official">Official</option>
                                <option value="Unofficial">Unofficial</option>
                            </select>

                            <span *ngIf="submitted && form.get('payment_type')?.hasError('required')" style="color:red"><strong>Please select Payment Type!</strong></span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Additional Duty Amount:<span style="color:red;">*</span></label>
                            <input type="text" formControlName="duty_amount"  class="form-control" placeholder="Duty Amount" value="">

                            <span *ngIf="submitted && form.get('duty_amount')?.hasError('required')" style="color:red"> <strong>Please enter duty amount!</strong></span>
                        </div>
                    </div>
                    <div class="col-md-4" *ngIf="isOfficialPmt">
                        <div class="form-group">
                            <label>Document Reference:<span style="color:red;">*</span></label>
                            <input type="text" formControlName="doc_ref_no" class="form-control" placeholder="Document Reference Number" [(ngModel)]="entry.data.doc_ref_no">

                            <span *ngIf="submitted && docRefNoIsEmpty" style="color:red"> <strong>Please enter Document Reference Number!</strong></span>
                        </div>
                    </div>
                </div>
                <div class="row clearfix" *ngIf="isOfficialPmt">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Payment Ref. Number:<span style="color:red;">*</span></label>
                            <input type="text" formControlName="payment_ref_no" class="form-control" placeholder="Payment Reference Number" value="">

                            <span *ngIf="submitted && pmtRefNoIsEmpty" style="color:red"> <strong>Please enter Payment Reference Number!</strong></span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Attach Payment Slip:<span style="color:red;">*</span></label>
                            <div class="input-group mb-3">
                                <div class="custom-file">
                                  <input type="file" formControlName="attachment" accept="application/pdf" class="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" (change)="onFileSelected($event)">
                                  <label class="custom-file-label" for="inputGroupFile01">{{ fileName }}</label>
                                </div>
                            </div>

                            <span *ngIf="submitted && attachmentIsEmpty" style="color:red"> <strong>Please add Payment Slip attachment!</strong></span>
                        </div>
                    </div>
                </div>
                <input type="hidden" formControlName="entry_id" [(ngModel)]="entry.data.entry_id">

                <button class="btn btn-success" type="button" *ngIf="isProcessing; else showSaveBtn" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Processing...
                </button>

                <ng-template #showSaveBtn>
                    <button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true">&nbsp;</i>Save</button>
                </ng-template>
           </form>
       </div>
       <!-- /.card-body -->
   </div>
   </div>
   </section>
